import {
  API_HOST,
  API_IMG_HOST,
  API_HOST_JAVA_SET
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import Vueaxios from 'vue-axiosp'
const axiosPhp = axios.create({
  baseURL: API_HOST
})
// axiosPhp.defaults.baseURL = API_HOST
axiosPhp.defaults.timeout = 1000 * 15
axiosPhp.defaults.headers.authKey = Lockr.get('authKey')
axiosPhp.defaults.headers.sessionId = Lockr.get('sessionId')
axiosPhp.defaults.headers['Content-Type'] = 'application/json'
axiosPhp.defaults.paramsSerializer = function (params) {
  return Qs.stringify(params)
}

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}

// 返回处理
axiosPhp.interceptors.response.use(function (response) {
  removePending(response) // 在一个ajax发送前执行一下取消操作
  if (response.data.code == 101) {
    // 清空登录信息
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
    Lockr.rm('userInfo')
    Lockr.rm('firstRoutePath')
    // // 跳转到登录页
    // router.push({path: '/login'})
    return response
  } else if (response.data.code > 101 && response.data.code != 200) {
    _g.toastMsg('error', response.data.error)
    if (response.data.code == 401) {
      // 跳转到登录页
      router.push({path: '/login'})
    }
    return response
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})
// 添加请求拦截器
axiosPhp.interceptors.request.use(config => {
  removePending(config) // 在一个ajax发送前执行一下取消操作
  config.cancelToken = new CancelToken((c) => {
    // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
    pending.push({
      u: config.url + '&' + config.method,
      f: c
    })
  })
  return config
}, error => {
  return Promise.reject(error)
})

// ====================== 营销活动 ====================== //
// 活动列表
export function getActivitys (t, page, search) {
  let url = 'activity/manage'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      t: t,
      page: page,
      search: search
    }
  })
}
// 创建活动
export function createActivitys (data) {
  let url = 'activity/manage'
  return axiosPhp.post(url, data)
}
// 活动详情
export function getActivitysDetail (id) {
  let url = 'activity/manage/' + id
  return axiosPhp.get(url)
}
// 编辑
export function editActivitys (id, data) {
  let url = 'activity/manage/' + id
  return axiosPhp.put(url, data)
}
// 活动列表 删除功能
export function deleteActivitys (id) {
  let url = 'activity/manage/' + id
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}
// 复制
export function copyAcivitys (id) {
  let url = 'activity/manage/copy/' + id
  return axiosPhp.get(url)
}
// 活动列表 开始活动功能
export function beginActivitys (id) {
  let url = 'activity/start/' + id
  return axiosPhp.get(url)
}
// 活动列表 结束活动功能
export function stopActivitys (id) {
  let url = 'activity/manage/enable'
  return axiosPhp.post(url, {
    ids: id
  })
}
// 活动统计
export function getActivitysStatics (id, page, search) {
  let url = 'activity/manage/statistic/' + id
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 活动导出
export function exportActivitys (id, search) {
  let url = 'activity/manage/export/' + id
  return axiosPhp({
    method: 'get',
    url: url,
    params: {
      search: search
    },
    responseType: 'blob'
  })
}

// 扫码导出
export function exportDrawcodeStatic (id, search) {
  let url = 'activity/manage/drawcodeexport/' + id
  return axiosPhp({
    method: 'get',
    url: url,
    params: {
      search: search
    },
    responseType: 'blob'
  })
}

// 获取公众号列表给自动化流程用
export function getWechatPublicListForNode (page) {
  let url = 'customer/wechatPublic'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: '',
      no_show_disable: 1
    }
  })
}
// 获取客户来源列表给微页面用
export function getCustomerSourceListForWepage (page) {
  let url = 'customer/source'
  return axiosPhp.get(url, {
    params: {
      limit: '',
      page: page
    }
  })
}
// 题库列表
export function getActivityQuestion (page, search) {
  let url = 'activity/question'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 编辑题面
export function editActivityQuestion (id, data) {
  let url = 'activity/question/' + id
  return axiosPhp.put(url, data)
}
// 添加题面
export function createActivityQuestion (data) {
  let url = 'activity/question'
  return axiosPhp.post(url, data)
}
// 题目详情
export function getActivityQuestionDetail (id) {
  let url = 'activity/question/' + id
  return axiosPhp.get(url)
}
// 活动首页，获取模板
export function getTemplate (data) {
  let url = 'activity/manage/templateindex'
  return axiosPhp.get(url, data)
}
// 活动奖品统计
export function getPrizeStatics (id, type) {
  let url = 'activity/manage/prizestatistic/' + id
  return axiosPhp.get(url, {
    params: {
      type: type
    }
  })
}
// 活动扫码统计
export function getDrawcodeStatics (id, page, search) {
  let url = 'activity/manage/drawcodestatistic/' + id
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
